import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axiosPost } from 'Redux/axiosHelper'
import { LeagueResultPayloadType } from 'types/league/leagueResult'

const AddGameResult = async (payload: LeagueResultPayloadType) => {
  const response = await axiosPost(payload, `v1/league-games-result`)
  return response.data
}
export const useAddGameResult = () => {
  const queryClient = useQueryClient()
  return useMutation(AddGameResult, {
    onSuccess: newData => {
      queryClient.invalidateQueries(['league-standings-by-id'])
    },
  })
}
